module.exports = __webpack_public_path__ + "img/noData.342425bd.png";